import MuiCardContent from '@mui/material/CardContent';
import type { ReactNode } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

export interface CardContentProps {
  sx?: SxProps<Theme>;
  children?: ReactNode;
}

export function CardContent({ sx, children }: CardContentProps) {
  return <MuiCardContent {...(sx !== undefined ? { sx } : {})}>{children}</MuiCardContent>;
}
